import React, { Component } from "react";
import Header from "../Login/Header";
import Footer from "./Footer";


class About extends Component {

  componentDidMount() {

  }

  render() {                                      


    return (
      <React.Fragment>
        <div className="container-fluid full-width nopadding">
          <div className="row nomargin">
            <div className="col-sm-12 header-color">
              <Header />
            </div>
          </div>
          <section class="breadcrumb-area">
            <div class="container">
              <div class="row">
                <div class="col-lg-12 col-sm-12 col-xs-12">
                  <div class="left-side pull-left pad10top headng">
                    <h1>About</h1>
                  </div>
                </div>
              </div>
            </div>
          </section>
          <div class="about-page">

            <section className="py-4">
              <div className="container">
                <div className="row no-margin">
                  <div className="row">
                    <div className="col-sm-12">
                      <div class="about-wrap mar-btm">
                        <div class="row">

                          <div class="col-md-12">
                            <div class="list-single-main-item-title fl-wrap">
                              <h3>Welcome to  <span>BeWise</span></h3>
                            </div>

                          <p>Our inspiration to create BeWise came from our vision to simplify the decision-making process for parents concerning their child&#39;s holistic development, besides enabling institutions &amp; Individuals serving these parents&#39;, to accelerate their brand building &amp; reach in the high paced &amp; evolving digital landscape.</p>

<p>Across different cities and countries, the BeWise team is made up of professionals like you who have faced similar challenges to your own, as parents working to help their children succeed in life. Keeping your child enrolled in a progressive ecosystem can be challenging when you&#39;re multitasking and prioritizing a range of professional and life responsibilities.</p>

<p><img class="abt-banner" src="https://www.bewise.in/assets/images/aboutus/aboutusbanner.png" /></p>

<p>A parent must make decisions that have a direct impact on the well-being &amp; growth of their child. Collaboration is needed, along with suggestions based on experience, to ensure that our decision-making is right, appropriate, and tailored to our child&#39;s uniqueness. It is BeWise&#39;s aim to make a positive impact on the parenting community through consistent improvement over time.</p>

<h2>Towards the Future</h2>

<p>We serve both relocating parents &amp; resident parents &amp; help in discovering the best suited option for both the parent &amp; child across all the areas of a child&#39;s learning. Fortunately, we have your back from activities to events &amp; this could range from a highly recommended private or public school or any after-school activities of interest, be it a musician, sports coach or a birthday event organizer. We&#39;ve got you covered keeping your time, budget, schedules, reviews, facilities and localities in mind.</p>

<p>We endeavour to deliver best outcomes that suit your needs, with best suited features of search engines, social media, and e-commerce all together at one single location with total focus &amp; emphasis for holistic education. By connecting you with parents and partner providers, BeWise will help you maximize value for time, effort, and money. Additionally your experience and inputs will contribute to helping raise the bar for the partner &amp; parent community.</p>

<h2>&nbsp;</h2>








          {/*
                            <div class="list-single-main-item-title fl-wrap">
                              <h3>Welcome to  <span>BeWise</span></h3>
                            </div>
                            <p className='termscond_para'>BeWise was born because we became engrossed with the idea of simplifying the parental experience of making holistic decisions about their child’s development journey.
                            </p>
                            <p className='termscond_para'>The team at BeWise are all professionals like you, and have faced the same challenges such as yourself, a parent, working hard to create a thriving future for your child, across different cities and countries. We understand the struggles of multitasking and prioritizing various professional and life responsibilities, while ensuring your child has access to all the benefits of a progressive ecosystem.
                            </p>
                            <p className='termscond_para'>These challenges and struggles got us to think of ways you could find a highly recommended private school with ease, being new in town. Or a Veena expert? Or catering, decorations and space for your child’s birthday?  All within your locality, in your budget, within your schedule?
                            </p>
                            <p className='termscond_para'>
                              Something that brought together the best values and experiences of the search engine, social media and e-commerce, all focused only on the holistic education for your child. On one website?
                            </p>

                            <p className='termscond_para'>BeWise connects you with parents and partner providers, in an efficient, unique, community driven method, providing you value for the time, effort and money you invest in decision making. BeWise remains transparent and neutral, relies on your experiences and learning, and helps you engage and connect with a larger parental community and service providers, all on one portal.
                            </p>
                            <p className='termscond_para'>BeWise, similarly offers institutional and individual partner providers an opportunity to monetise their marketing spends by showcasing their service offerings to an audience that is progressive and digitally savvy.
                            </p>
                            <div class="list-single-main-item-title fl-wrap">
                              <h3>The Journey Ahead</h3>
                            </div>
                            <p className='termscond_para'>We are aware of the importance and urgency associated with the entire journey of child care, the transformative decisions that a parent must make that impacts the child’s well being, the need for collaboration, and experience driven suggestions that we strive to find to  ensure our decisions are correct, and suited for the uniqueness that is our child.

                            </p>
                            <p className='termscond_para'>BeWise is keen to make a difference to the parental community and we seek your support / feedback to make it consistently more valuable to all.

                            </p>
                            <p className='termscond_para'>BeWise invites you to join us and forge a community that strives for the larger development of our future!

                            </p>
                          </div>

                          
                  */ }  
                   </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </div>
        </div>
        <Footer />

      </React.Fragment>
    );
  }
}

export default About;



// WEBPACK FOOTER //
// ./src/components/Copyrights/about.jsx